import React from 'react';
import { Router, Route, IndexRedirect } from 'react-router';

import CompanyHierarchy from '@src/features/company-hierarchy';
// Routes
import * as routes from './const';

// Higher Order Components
import CanView from '../auth/CanView';

// Layouts
import EmptyLayout from '../layouts/global/EmptyLayout';
import FleetLayout from '../layouts/fleet/FleetLayout';
import LoginLayout from '../layouts/global/LoginLayout';
import CanViewContainer from '../layouts/global/CanViewContainer';
import FleetPageLayout from '../layouts/fleet/FleetPageLayout';
import ReportingLayout from '../layouts/fleet/ReportingLayout';

import FooterLayout from '../layouts/global/FooterLayout';
import FbtLayout from '../layouts/fbt/FbtLayout';
import FbtPageLayout from '../layouts/fbt/FbtPageLayout';
import FleetDashboardLayout from '../layouts/fleet/FleetDashboardLayout';
// Login
import Login from '../features/login/Login';
import Logout from '../features/logout/Logout';
import LoginEnterprise from '../features/login/login-enterprise/LoginEnterprise';

// Not found
import NotFound from '../features/not-found/NotFound';

// Corporate Quote
import CorporateQuote from '../features/corporate-quote/CorporateQuote';
import CreateQuote from '../features/corporate-quote/create/CreateQuote';
import QuoteQuestions from '../features/corporate-quote/create/QuoteQuestions';
import QuoteSource from '../features/corporate-quote/create/QuoteSource';
import QuoteVehicle from '../features/corporate-quote/create/QuoteVehicle';
import QuoteOptions from '../features/corporate-quote/create/QuoteOptions';
import QuoteDeclined from '../features/corporate-quote/create/QuoteDeclined';
import QuoteDelivery from '../features/corporate-quote/create/QuoteDelivery';
import QuoteSummary from '../features/corporate-quote/create/QuoteSummary';
import QuoteSubmitted from '../features/corporate-quote/create/QuoteSubmitted';
// Corporate Quote - lease Details & options
import CreateLease from '../features/corporate-quote/create/CreateLease';
// Corportate Quote - quote approval
import QuoteApproval from '../features/corporate-quote/workflow/QuoteApproval';
import MyQuote from '../features/corporate-quote/workflow/MyQuote';

// Profile
import Profile from '../features/profile/Profile';

// insights
import Insights from '../features/insights/Insights';
import InsightsDetail from '../features/insights/InsightsDetail';
import TableDetails from '../features/insights/TableDetails';

// Fuel Cards
import FuelCards from '../features/fuel-cards';

// Yellowfin
import YFEmbedDisplay from '../features/yellowfin/EmbedDisplayContainer';
import PowerBIEmbedDisplay from '../features/powerbi/EmbedDisplay';

// Scheduling Reports
import BusinessReports from '../features/scheduling-reports/business-reports';
import LegacyReports from '../features/scheduling-reports/legacy-reports/LegacyReports';
import MyReports from '../features/scheduling-reports/my-reports';
import ReportEdit from '../features/scheduling-reports/report-edit';

// Relocation
import VehicleCostcenterChange from '../features/relocations/vehicle/VehicleCostcenterChange';
import DriverAllocation from '../features/relocations/driver/DriverAllocation';

// Accident Management
import AccidentManagement from '../features/accident-management';
import Telematics from '../features/telematics';
import Auth0Redirect from '../features/auth-0-redirect';
import LegacyLogoutSync from '../features/legacy-logout-sync';
import LegacyLoginSync from '../features/legacy-login-sync';

// Quote WorkFlow
import WorkflowQuoteSummary from '../features/corporate-quote/workflow/QuoteSummary';

// ERROR handle
import HttpErrorsRedirect from '../features/errors/httpErrors/HttpErrorsRedirect';

// Bookmarks
import BookmarksPage from '../features/common/Bookmarks/containers/BookmarksPage';
// User Management
import UserManagementContainer from '../features/userManagement/UserManagementContainer';
import UserDetailContainer from '../features/userManagement/UserDetailContainer';

// AdminRoutes
import UserEdit from '../features/admin/components/UserEdit';
import UserBulkImport from '../features/admin/components/UserBulkImport';
import AdminRoutes from '../features/users/routes/index';
// src/features/Admin/routes/index.js
import Fbtroutes from '../features/fbt/routes/index';

import MainLayoutWide from '../layouts/MainLayoutWide';
import CorporateQuoteWorkflowSetup from '../features/corporate-quote-workflow-setup/WorkflowSetup';

import { Notification, NotificationSettings } from '../features/notification';

import DashboardProfileRoutes from '../features/dashboard/routes';

import FiltersContainer from '../features/scheduling-reports/new-report/Filters/FiltersContainer';

import SearchResult from '../features/common/GlobalSearchBar/SearchResultGrid';

const createRoutes = store => (
  <Router>
    <Route component={LegacyLoginSync}>
      <Route component={LoginLayout}>
        <Route path={routes.LOGIN} component={Login} />
        <Route path={routes.LOGOUT} component={Logout} />
        <Route path={routes.EnterpriseConnection} component={LoginEnterprise} />
      </Route>

      <Route component={EmptyLayout}>
        <Route path={routes.Quote_Summary} component={WorkflowQuoteSummary} />
        <Route path={routes.HTTP_ERROR_HANDLE} component={HttpErrorsRedirect} />
        <Route path={routes.CompleteAuth0Login} component={Auth0Redirect} />
        <Route path={routes.CompleteAuth0Logout} component={LegacyLogoutSync} />
      </Route>

      <Route path={routes.APP_ROOT} component={CanView(CanViewContainer)}>
        <Route component={FbtLayout}>
          <Route component={FbtPageLayout}>{Fbtroutes(store)}</Route>
          <Route component={FbtPageLayout}>
            <Route path={routes.FBT_DRIVER_REPORT} component={TableDetails} />
          </Route>
        </Route>

        <Route component={FleetLayout}>
          <Route path={routes.PROFILE} component={Profile} />
          <Route path={routes.SEARCH_RESULT} component={SearchResult} />

          <Route path={routes.MY_BOOKMARKS} component={BookmarksPage} />

          <Route component={FleetDashboardLayout}>
            {DashboardProfileRoutes}
          </Route>

          <Route component={FooterLayout}>
            <Route path={routes.FUEL_CARDS} component={FuelCards} />
            <Route path={routes.INSIGHTS} component={Insights} />
            <Route path={routes.TABLEDETAIL} component={TableDetails} />
            <Route
              path={routes.SUMMARYDETAIL}
              component={PowerBIEmbedDisplay}
            />
          </Route>

          <Route component={FleetPageLayout}>
            <Route path={routes.FLEET}>
              <Route
                path={routes.COMPANY_HIERARCHY}
                component={CompanyHierarchy}
              />

              <Route path={routes.CQ_ROOT} component={CorporateQuote}>
                <Route path={routes.CQ_CREATE} component={CreateQuote}>
                  <IndexRedirect to={routes.CQ_CREATE_QUESTIONS} />
                  <Route
                    path={routes.CQ_CREATE_QUESTIONS}
                    component={QuoteQuestions}
                  />
                  <Route
                    path={routes.CQ_CREATE_SOURCE}
                    component={QuoteSource}
                  />
                  <Route
                    path={routes.CQ_CREATE_VEHICLE}
                    component={QuoteVehicle}
                  />
                  <Route
                    path={routes.CQ_CREATE_OPTIONS}
                    component={QuoteOptions}
                  />
                  <Route
                    path={routes.CQ_CREATE_DECLINED}
                    component={QuoteDeclined}
                  />
                  <Route
                    path={routes.CQ_CREATE_LEASE}
                    component={CreateLease}
                  />
                  <Route
                    path={routes.CQ_CREATE_DELIVERY}
                    component={QuoteDelivery}
                  />
                  <Route
                    path={routes.CQ_CREATE_SUMMARY}
                    component={QuoteSummary}
                  />
                  <Route
                    path={routes.CQ_CREATE_SUBMITTED}
                    component={QuoteSubmitted}
                  />
                </Route>
                <Route path={routes.CQ_APPROVAL} component={QuoteApproval} />
                <Route path={routes.CQ_MYQUOTE} component={MyQuote} />
              </Route>

              <Route path={routes.TRANSFERS_ROOT}>
                <Route
                  path={routes.CQ_CREATE_QUESTIONS}
                  component={QuoteQuestions}
                />
                <Route
                  path={routes.CQ_CREATE_VEHICLE}
                  component={QuoteVehicle}
                />
                <Route
                  path={routes.CQ_CREATE_OPTIONS}
                  component={QuoteOptions}
                />
                <Route
                  path={routes.CQ_CREATE_DECLINED}
                  component={QuoteDeclined}
                />
                <Route path={routes.CQ_CREATE_LEASE} component={CreateLease} />
                <Route
                  path={routes.CQ_CREATE_DELIVERY}
                  component={QuoteDelivery}
                />
                <Route
                  path={routes.CQ_CREATE_SUMMARY}
                  component={QuoteSummary}
                />
                <Route
                  path={routes.CQ_CREATE_SUBMITTED}
                  component={QuoteSubmitted}
                />
              </Route>

              <Route path={routes.CQ_APPROVAL} component={QuoteApproval} />
            </Route>

            <Route path={routes.TRANSFERS_ROOT}>
              <Route
                path={routes.TRANSFERS_VEHICLE}
                component={VehicleCostcenterChange}
              />
              <Route
                path={routes.TRANSFERS_DRIVER}
                component={DriverAllocation}
              />
            </Route>

            <Route path={routes.REPORTS}>
              <Route path={routes.REPORTS_BUILDER}>
                <IndexRedirect to={routes.RB_BUSINESS_REPORTS} />
                <Route
                  path={routes.RB_BUSINESS_REPORTS}
                  component={BusinessReports}
                />

                <Route
                  path="/reports/build/debug-path"
                  component={FiltersContainer}
                />

                <Route
                  path={routes.RB_LEGACY_REPORTS}
                  component={LegacyReports}
                />
                <Route path={routes.RB_MY_REPORTS} component={MyReports} />
                <Route path={routes.RB_REPORT_EDIT} component={ReportEdit} />
              </Route>

              <Route path={routes.REPORT_DETAIL} component={InsightsDetail} />
            </Route>
          </Route>

          <Route path={routes.NOTIFICATION}>
            <Route path={routes.NOTIFICATION_CENTER} component={Notification} />
            <Route
              path={routes.NOTIFICATION_SETTINGS}
              component={NotificationSettings}
            />
          </Route>

          <Route component={ReportingLayout}>
            <Route path={routes.REPORTS}>
              <Route
                path={routes.REPORT_YELLOWFIN}
                component={YFEmbedDisplay}
              />
              <Route
                path={routes.REPORT_POWERBI_EMBED}
                component={PowerBIEmbedDisplay}
              />
            </Route>
          </Route>

          <Route
            path={routes.ACCIDENT_MANAGEMENT_CLAIMS}
            component={AccidentManagement}
          />

          <Route path={routes.TELEMATICS_DASHBOARD} component={Telematics} />

          <Route path={routes.USERS_MANAGEMENT}>
            <IndexRedirect to={routes.USERS_MANAGEMENT_USER_LISTING} />
            <Route
              path={routes.USERS_MANAGEMENT_USER_LISTING}
              component={UserManagementContainer}
            />
            <Route
              path={routes.USERS_MANAGEMENT_USER_DETAIL}
              component={UserDetailContainer}
            />
          </Route>

          {AdminRoutes(store)}
          <Route path={routes.ADMINNEW} component={MainLayoutWide}>
            <Route path={routes.USER_NEW} component={UserEdit} />
            <Route path={routes.USER_EDIT} component={UserEdit} />
            <Route path={`${routes.USER_EDIT}/:id`} component={UserEdit} />
            <Route path={routes.USER_BULK_UPLOAD} component={UserBulkImport} />
          </Route>

          <Route path={routes.ADMIN} component={MainLayoutWide}>
            <Route
              path={routes.CORPORATE_QUOTE_WORKFLOW_SETUP}
              component={CorporateQuoteWorkflowSetup}
            />
          </Route>
        </Route>
      </Route>

      <Route path="*" component={NotFound} />
    </Route>
  </Router>
);

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.js